import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { presentationsApi } from '../../../api/presentationsApi'
import { routes } from '../../../constantes/routes'
import { swalAlertError } from '../../../utils/swalAlert'
import { hospitalsContactsActions } from '../../../actions/hospitalsContactsActions'
import ReactModal from 'react-modal'
import CloseBtn from '../../buttons/CloseBtn'
import NewPresentationForm from './NewPresentationForm'
import { presentationsActions } from '../../../actions/presentationsActions'
import validators from '../../../utils/validationsRegEx'

const NewPresentationContainer = ({ modalIsOpen, closeModal }) => {
  const history = useHistory()

  const hospitalsContacts = useSelector((state) => state.hospitalsContacts)
  const userProfile = useSelector((state) => state.userProfile)

  const dispatch = useDispatch()
  const getAllHospitalContacts = () =>
    dispatch(hospitalsContactsActions.getAllContactsHospitals())

  const [hospitals, setHospitals] = useState([])
  // lista de los contactos del hospital seleccionado
  const [hospitalSpeciality, setHospitalSpeciality] = useState([])
  const [idContactHopitalSelected, setIdContsctHopitalSelected] = useState('')
  const [isDisable, setIsDisable] = useState(false)

  //valores de los inputs introducidos en el modal
  const [inputs, setinputs] = useState({
    nombre: '',
    id_Hospital: '',
    id_Contacto: '',
  })

  useEffect(() => {
    getAllHospitalContacts()
  }, [])

  const handleChange = (event) => {
    const value = event.target.value
    const name = event.target.name
    setinputs((inputs) => ({ ...inputs, [name]: value }))
    if (name === 'id_Contacto') {
      getHospitals(value)
    } else if (name === 'id_Hospital') {
      changeHospitalSpeciality(value)
    }
  }

  const getHospitals = (value) => {
    const filterHospitalsByContact = hospitalsContacts.find(
      (contact) => contact.id_Contacto == value,
    )
    setHospitals(filterHospitalsByContact.hospitalsContacts)
    setHospitalSpeciality('')
  }

  const changeHospitalSpeciality = (value) => {
    const hospital = hospitals.find((hospital) => hospital.id_Hospital == value)
    setHospitalSpeciality(hospital.hospitalSpeciality)
    setIdContsctHopitalSelected(hospital.id_ContactoHospital)
  }

  const handleSubmitCreateNewPresentation = async (event) => {
    event.preventDefault()
    setIsDisable(true)
    const dataPresentation = {
      nombre: inputs.nombre,
      id_Contacto: inputs.id_Contacto,
      id_Hospital: inputs.id_Hospital,
    }
    // Primero creamos una presentacion asignandole un nombre, y que nos devuelva el id_presentacion
    try {
      const responseNewPresentation = await presentationsApi.newPresentation(
        dataPresentation,
      )

      if (responseNewPresentation.data.id_Presentacion) {
        const dataContactsPresentations = {
          id_Presentacion: responseNewPresentation.data.id_Presentacion,
          id_ContactosHospitales: idContactHopitalSelected,
        }
        // Una vez creada la presention, guaradmos la informacion en la tabla ContactosPresentaciones
        // mostrarmos el catalogo con los productos para que se pueda añadir a la presentación
        await addContactToPresentation(dataContactsPresentations)
      }
    } catch (error) {
      swalAlertError(error.response.data || error.response.statusText)
      setIsDisable(false)
    }
  }

  //Submit
  const addContactToPresentation = async (dataContactsPresentations) => {
    try {
      // Una vez creada la presention, guaradmos la informacion en la tabla ContactosPresentaciones
      const response = await dispatch(
        presentationsActions.newPresentationContactHospital(
          dataContactsPresentations,
        ),
      )
      if (response.payload) {
        closeModal()
        history.push(
          routes.PRESENTATION_ADD_PRODUCTS +
            dataContactsPresentations.id_Presentacion,
        )
      }
    } catch (error) {
      swalAlertError(error.response.data || error.response.statusText)
      history.push(routes.PRESENTATION)
      setIsDisable(false)
    }
  }

  const validateForm = () => {
    return (
      validators.hasValue(inputs.nombre) &&
      validators.hasValue(inputs.id_Hospital) &&
      validators.hasValue(inputs.id_Contacto)
    )
  }

  const customStyles = {
    content: {
      width: '90%',
      maxWidth: '600px',
      height: 'auto',
      maxHeight: '80vh',
      overflow: 'auto',
    },
  }

  return (
    <ReactModal
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      style={customStyles}
      contentLabel='Añadir artículo'
      className='custom-modal'
      ariaHideApp={false}
    >
      <span className='custom-modal__close' onClick={closeModal}>
        <CloseBtn />
      </span>
      <h4 className='custom-modal__title'>Crear nueva presentación</h4>

      <NewPresentationForm
        hospitals={hospitals}
        hospitalsContacts={hospitalsContacts}
        hospitalSpeciality={hospitalSpeciality}
        handleChange={handleChange}
        inputs={inputs}
        handleSubmitCreateNewPresentation={handleSubmitCreateNewPresentation}
        isDisable={isDisable || !validateForm()}
      />
    </ReactModal>
  )
}
ReactModal.setAppElement('#root')
export default NewPresentationContainer
